module.exports = __webpack_public_path__ + "img/phone-ic.9b516308.svg";